export var baseTypesMap = {
  BaseClassifierNode: 'BaseClassifierNode',
  UserClassifierNode: 'UserClassifierNode',
  UserClassifierGroupWithGroupsNode: 'UserClassifierGroupNode',
  UserClassifierGroupWithElementsNode: 'UserClassifierGroupNode',
  UserClassifierEmptyGroupNode: 'UserClassifierGroupNode',
  UserClassifierGroupNode: 'UserClassifierGroupNode',
  DynamicBaseGroupNode: 'DynamicBaseGroupNode',
  DynamicGeneratedGroupNode: 'DynamicGeneratedGroupNode',
  AssemblyClassifierNode: 'AssemblyClassifierNode',
  AnonymousClassifierNode: 'AnonymousClassifierNode',
  BimModelReferenceNode: 'ReferenceNode',
  BimCategoryReferenceNode: 'ReferenceNode',
  BimFamilyReferenceNode: 'ReferenceNode',
  BimStandardSizeReferenceNode: 'ReferenceNode',
  BimElementReferenceNode: 'ReferenceNode',
  DynamicBimElementReferenceNode: 'DynamicBimElementReferenceNode',
  // TODO, при появлении других GeneratedReference объединить в один тип
  BimModelNode: 'BimModelNode',
  BimCategoryNode: 'BimCategoryNode',
  BimFamilyNode: 'BimFamilyNode',
  BimStandardSizeNode: 'BimStandardSizeNode',
  BimElementNode: 'BimElementNode'
};